import React, {useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import TypographyWithIcon from "components/TypographyWithIcon";
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import AgreementsService from "services/AgreementsService";
import SimpleSelect from "components/SimpleSelect";
import Confirm from "components/popup/confirm/Confirm";


function AgreementCreatePopup(
    {
        onClose,
        onSubmit,
        agreementsAvailableOrganizationsList,
        userData
    }) {

    const [value, setValue] = useState(() => {
        const elem = agreementsAvailableOrganizationsList.find(x => x.orgId === userData.orgId);
        return elem ? elem : agreementsAvailableOrganizationsList[0];
    });

    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleSubmit = (oneAgreement) => {
        onSubmit(value, oneAgreement);
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), () => {
            onClose();
        }, 'outlined', false));
        buttons.push(createButton(Tr('createSingleAgreements'), () => {
            handleSubmit(false);
        }, undefined, false));
        buttons.push(createButton(Tr('createOneAgreement'), () => {
            setConfirmOpen(true);
        }, undefined, false));
        return buttons;
    }

    return (
        <>
            <Dialog
                title={Tr('agreement_create')}
                open={true}
                maxWidth={'md'}
                dialogActions={<MultiButton buttons={getButtons()} />}
            >

                <GridBlock column>

                    <TypographyWithIcon Icon={InfoOutlinedIcon}>
                        {Tr("agreement_create_select_org")}
                    </TypographyWithIcon>
                    <SimpleSelect
                        label={Tr('organizational_unit')}
                        items={agreementsAvailableOrganizationsList.map(x => ({label: x.name, value: x}))}
                        value={value}
                        onChange={(e) => {
                            setValue(e.target.value);
                        }}
                    />

                </GridBlock>

            </Dialog>

            <Confirm
                confirmText={Tr('createOneAgreement_info')}
                onCancel={() => setConfirmOpen(false)}
                onConfirm={() => {
                    setConfirmOpen(false);
                    handleSubmit(true);
                }}
                open={confirmOpen}
                translateConfirmTexts={false}
            />
        </>
    )
}

AgreementCreatePopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default connect((state) => ({
    agreementsAvailableOrganizationsList: state.resources[AgreementsService.AGREEMENTS_AVAILABLE_ORGANIZATIONS_RESOURCE_ID],
    userData: state.resources.userData
}), {})(AgreementCreatePopup);